// extracted by mini-css-extract-plugin
export default {"article":"Info_article__YYfli","link":"Info_link__ISWeQ","tabContainer":"Info_tabContainer__liJ0T","articles":"Info_articles__zmBNU"};